import React from 'react';

const TONES = {
  primary: 'bg-primary-50 text-primary-700 dark:bg-primary-900/30 dark:text-primary-300',
  blue: 'bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
  green: 'bg-green-50 text-green-700 dark:bg-green-900/30 dark:text-green-300',
  amber: 'bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
  red: 'bg-red-50 text-red-700 dark:bg-red-900/30 dark:text-red-300',
  purple: 'bg-purple-50 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300',
};

/**
 * Compact metric card used on list pages (Projects, Tasks, etc.).
 */
const StatCard = ({ icon: Icon, label, value, tone = 'primary', onClick, active = false }) => {
  const interactive = typeof onClick === 'function';
  return (
    <div
      role={interactive ? 'button' : undefined}
      tabIndex={interactive ? 0 : undefined}
      onClick={onClick}
      onKeyDown={
        interactive
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick(e);
              }
            }
          : undefined
      }
      className={`bg-white dark:bg-secondary-800 border rounded-2xl shadow-sm p-4 flex items-center gap-4 transition-colors ${
        active
          ? 'border-primary-500 ring-2 ring-primary-500/20'
          : 'border-secondary-200 dark:border-secondary-700'
      } ${interactive ? 'cursor-pointer hover:border-primary-300 dark:hover:border-primary-600' : ''}`}
    >
      <div
        className={`h-11 w-11 rounded-xl flex items-center justify-center flex-shrink-0 ${TONES[tone] || TONES.primary}`}
      >
        {Icon ? <Icon className="h-5 w-5" /> : null}
      </div>
      <div className="min-w-0">
        <div className="text-2xl font-semibold text-secondary-900 dark:text-white leading-tight truncate">
          {value}
        </div>
        <div className="text-xs text-secondary-500 dark:text-secondary-400 mt-0.5">{label}</div>
      </div>
    </div>
  );
};

export default StatCard;
